var app = angular.module('leonardo');

var ErrorDirective = function(ConfigThemeService) {
  return {
    restrict: 'C',
    scope: true,
    link: function (scope, element) {

      scope.setColor = function() {
        element.css('color', ConfigThemeService.getColor('errorColor'));
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('error', ['ConfigThemeService', ErrorDirective]);
